function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M56.0629 51.8475C28.4481 75.2282 3.0425 100.818 0.64884 128.433C-1.9285 156.232 18.6907 185.872 38.7575 211.461C58.8243 237.235 78.1546 258.959 103.376 270.742C128.414 282.524 159.527 284.365 182.355 272.398C205.183 260.432 219.911 234.474 236.112 208.516C252.313 182.374 269.986 156.232 272.564 126.224C274.957 96.3998 262.254 62.5252 238.137 38.4084C214.02 14.2912 178.489 -0.0685029 145.903 3.42948C113.318 6.92746 83.678 28.2827 56.0629 51.8475Z",
  fill: "#2E365D"
});

var _ref3 = /*#__PURE__*/React.createElement("mask", {
  id: "mask0",
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 2,
  width: 273,
  height: 279
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M145.473 3.42931C112.887 6.92729 83.2478 28.2826 55.6326 51.8474C28.0179 75.228 2.61225 100.818 0.219035 128.433C-2.35831 156.232 18.2604 185.872 38.3273 211.462C58.3941 237.236 77.7248 258.959 102.946 270.742C127.984 282.524 159.096 284.365 181.925 272.399C204.753 260.432 219.481 234.474 235.682 208.516C251.883 182.374 269.556 156.232 272.134 126.224C274.527 96.3996 261.824 62.5254 237.707 38.4083C216.009 16.7098 185.064 2.90963 155.345 2.90784C152.032 2.90739 148.741 3.07853 145.473 3.42931Z",
  fill: "white"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M128.322 56.7303L98.7993 82.7659C98.7993 82.7659 96.2421 86.0201 94.615 94.1567C92.9878 102.292 87.55 188.719 79.6056 199.311C71.6612 209.904 49.5932 246.978 49.5932 246.978L107.852 295.086L136.21 219.172C136.21 219.172 159.923 197.7 156.833 178.733C156.833 178.733 141.819 65.728 128.322 56.7303Z",
  fill: "#C88E74"
}));

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M186.966 36.9809C186.966 36.9809 200.14 21.4273 207.374 26.2249C213.96 30.5925 200.48 49.9434 192.757 56.5626L186.966 36.9809Z",
  fill: "#C88E74"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M193.91 61.35C193.91 61.35 212.561 50.2679 214.068 49.3257C215.576 48.384 221.793 45.8407 224.147 48.2895C226.502 50.7387 223.206 60.2529 215.387 66.4698C207.569 72.6867 198.049 78.7154 198.049 78.7154L193.91 61.35Z",
  fill: "#C88E74"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M199.844 81.9183L216.894 72.6868C216.894 72.6868 223.205 70.2376 225.843 74.1939C228.48 78.1502 224.524 83.0486 223.111 84.8383C221.698 86.6281 201.351 101.7 201.351 101.7L199.844 81.9183Z",
  fill: "#C88E74"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M202.953 105.562L211.054 101.7C211.054 101.7 215.858 99.8159 218.495 103.113C221.133 106.41 218.024 115.641 206.626 120.351L202.953 105.562Z",
  fill: "#C88E74"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M140.76 195.237L209.371 181.645C214.507 180.628 217.845 175.639 216.828 170.503L184.908 9.38019C183.89 4.24477 178.902 0.905825 173.766 1.92323L105.155 15.516C100.02 16.5334 96.6807 21.5219 97.6985 26.6578L129.619 187.781C130.636 192.916 135.624 196.255 140.76 195.237Z",
  fill: "#202447"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M143.618 194.497L212.229 180.904C217.365 179.887 220.703 174.899 219.686 169.763L187.765 8.63949C186.748 3.50362 181.759 0.165119 176.624 1.18253L108.013 14.7753C102.877 15.7927 99.5384 20.7807 100.556 25.9166L132.476 187.04C133.494 192.176 138.482 195.514 143.618 194.497Z",
  fill: "white"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M136.887 33.4365L123.047 36.2103L125.821 50.0498L139.661 47.2759L136.887 33.4365Z",
  fill: "#17204B"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M136.887 33.4365L144.787 31.853L145.184 33.8328L147.164 33.436L146.767 31.4562L150.717 30.6645L151.114 32.6443L149.143 33.0392L149.538 35.0095L147.558 35.4063L147.955 37.3861L149.935 36.9893L150.332 38.969L148.352 39.3658L148.747 41.3362L146.767 41.733L147.164 43.7127L145.194 44.1077L144.402 40.1576L146.372 39.7627L145.976 37.7829L144.005 38.1778L143.213 34.2277L139.254 35.0213L141.631 46.881L143.611 46.4842L143.214 44.5045L145.194 44.1077L145.985 48.0577L136.096 50.0399L136.493 52.0196L134.523 52.4145L134.919 54.3943L130.96 55.1879L130.563 53.2081L132.543 52.8113L132.146 50.8316L130.166 51.2284L130.563 53.2081L126.613 53.9999L125.821 50.0498L139.661 47.2759L136.887 33.4365Z",
  fill: "white"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M146.767 31.4562L144.787 31.853L145.184 33.8328L147.163 33.436L146.767 31.4562Z",
  fill: "#17204B"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M152.697 30.2677L150.717 30.6646L151.114 32.6443L153.093 32.2475L152.697 30.2677Z",
  fill: "#17204B"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M152.697 30.2677L158.626 29.0792L161.4 42.9187L175.24 40.1448L176.031 44.0949L174.052 44.4917L173.655 42.5119L163.775 44.4922L164.172 46.4719L162.192 46.8687L161.795 44.889L157.845 45.6807L158.242 47.6605L160.212 47.2655L161.004 51.2156L162.984 50.8188L164.172 56.7487L168.122 55.957L167.331 52.0069L169.31 51.6101L170.896 59.5197L168.916 59.9165L168.519 57.9367L166.549 58.3316L166.946 60.3114L162.986 61.105L161.401 53.1954L159.43 53.5903L160.619 59.5201L156.659 60.3137L157.056 62.2935L155.086 62.6884L154.689 60.7087L152.709 61.1055L152.313 59.1257L148.362 59.9174L148.759 61.8972L146.78 62.294L146.383 60.3142L144.403 60.711L144.008 58.7407L142.038 59.1356L141.641 57.1559L137.681 57.9495L138.078 59.9292L136.108 60.3241L135.711 58.3444L133.731 58.7412L134.128 60.7209L136.108 60.3241L136.503 62.2945L138.473 61.8996L138.87 63.8793L136.9 64.2742L137.296 66.254L129.387 67.8393L128.99 65.8595L134.92 64.671L134.523 62.6913L132.543 63.0881L132.148 61.1177L130.178 61.5127L130.573 63.483L128.593 63.8798L127.801 59.9297L131.752 59.138L131.355 57.1582L137.285 55.9697L136.493 52.0196L142.423 50.8311L142.82 52.8109L144.799 52.4141L145.194 54.3844L149.144 53.5927L149.541 55.5724L147.571 55.9673L147.968 57.9471L151.918 57.1554L150.729 51.2255L152.709 50.8287L153.501 54.7788L155.471 54.3839L155.868 56.3637L153.897 56.7586L154.292 58.7289L158.242 57.9372L157.451 53.9871L155.471 54.3839L155.074 52.4041L159.034 51.6105L158.639 49.6402L154.679 50.4338L153.491 44.504L155.47 44.1072L154.282 38.1773L152.302 38.5741L151.905 36.5944L149.935 36.9893L149.538 35.0095L151.509 34.6146L151.114 32.6443L153.093 32.2475L152.697 30.2677Z",
  fill: "white"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M172.466 26.3053L158.627 29.0791L161.4 42.9185L175.24 40.1447L172.466 26.3053Z",
  fill: "#17204B"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M135.304 35.813L125.424 37.7932L127.404 47.6731L137.284 45.6929L135.304 35.813Z",
  fill: "white"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M139.254 35.0214L143.213 34.2278L144.005 38.1778L142.025 38.5746L142.422 40.5544L144.402 40.1576L145.194 44.1077L143.214 44.5045L143.611 46.4842L141.631 46.881L139.254 35.0214Z",
  fill: "#17204B"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M151.123 32.6424L149.143 33.0392L149.54 35.0189L151.52 34.6221L151.123 32.6424Z",
  fill: "#17204B"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M157.053 31.4538L155.073 31.8506L156.658 39.7602L158.638 39.3634L157.053 31.4538Z",
  fill: "#17204B"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M170.883 28.6819L161.003 30.6621L162.983 40.542L172.863 38.5618L170.883 28.6819Z",
  fill: "white"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M133.719 38.1801L127.789 39.3687L128.978 45.2985L134.908 44.11L133.719 38.1801Z",
  fill: "#17204B"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M149.538 35.0094L147.558 35.4062L147.955 37.386L149.935 36.9892L149.538 35.0094Z",
  fill: "#17204B"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M169.298 31.049L163.368 32.2375L164.557 38.1674L170.487 36.9789L169.298 31.049Z",
  fill: "#17204B"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M144.005 38.1778L142.025 38.5746L142.422 40.5543L144.402 40.1575L144.005 38.1778Z",
  fill: "white"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M145.985 37.7809L144.005 38.1777L144.402 40.1575L146.382 39.7607L145.985 37.7809Z",
  fill: "#17204B"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M149.935 36.9892L151.905 36.5943L152.302 38.574L154.282 38.1772L155.47 44.1071L153.491 44.5039L153.094 42.5241L151.123 42.919L150.727 40.9393L148.747 41.3361L148.352 39.3657L150.332 38.9689L149.935 36.9892Z",
  fill: "#17204B"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M148.747 41.3361L146.767 41.7329L147.164 43.7127L149.144 43.3159L148.747 41.3361Z",
  fill: "#17204B"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "M150.727 40.9394L148.747 41.3362L149.144 43.3159L151.124 42.9191L150.727 40.9394Z",
  fill: "white"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "M145.194 44.1076L147.164 43.7127L147.561 45.6924L149.541 45.2956L149.144 43.3159L151.123 42.9191L151.52 44.8988L153.491 44.5039L154.679 50.4338L158.639 49.6402L159.034 51.6105L155.074 52.4041L155.471 54.3838L153.501 54.7788L152.709 50.8287L150.729 51.2255L151.918 57.1553L147.967 57.947L147.571 55.9673L149.541 55.5724L149.144 53.5926L145.194 54.3843L144.799 52.414L146.779 52.0172L146.382 50.0374L152.312 48.8489L151.915 46.8692L145.985 48.0577L145.194 44.1076Z",
  fill: "#17204B"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  d: "M149.144 43.316L147.164 43.7128L147.561 45.6925L149.541 45.2957L149.144 43.316Z",
  fill: "white"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  d: "M153.103 42.5223L151.124 42.9191L151.52 44.8988L153.5 44.502L153.103 42.5223Z",
  fill: "white"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  d: "M159.033 41.3337L157.053 41.7305L157.45 43.7102L159.43 43.3134L159.033 41.3337Z",
  fill: "#17204B"
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  d: "M132.146 50.8316L130.166 51.2284L130.563 53.2082L132.543 52.8113L132.146 50.8316Z",
  fill: "#17204B"
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  d: "M136.096 50.0398L145.985 48.0577L146.382 50.0374L144.402 50.4342L144.799 52.414L142.82 52.8108L142.423 50.831L136.493 52.0196L136.096 50.0398Z",
  fill: "#17204B"
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  d: "M151.915 46.8691L145.985 48.0576L146.382 50.0374L152.312 48.8489L151.915 46.8691Z",
  fill: "white"
});

var _ref37 = /*#__PURE__*/React.createElement("path", {
  d: "M157.845 45.6806L161.795 44.8889L162.192 46.8687L164.172 46.4719L163.775 44.4921L173.655 42.5119L174.052 44.4916L172.072 44.8884L172.864 48.8385L170.893 49.2334L171.687 53.1929L173.657 52.798L174.449 56.7481L172.479 57.143L173.27 61.0931L175.241 60.6982L175.637 62.678L171.687 63.4697L172.479 67.4198L174.459 67.023L174.856 69.0027L176.826 68.6078L177.223 70.5876L181.182 69.794L181.577 71.7643L171.688 73.7464L171.293 71.7761L173.273 71.3793L172.876 69.3995L170.896 69.7963L171.293 71.7761L169.323 72.171L168.926 70.1912L166.946 70.588L168.134 76.5179L176.044 74.9326L176.441 76.9123L160.622 80.083L160.225 78.1032L164.184 77.3096L163.788 75.3298L161.808 75.7266L160.619 69.7968L162.599 69.4L162.204 67.4297L158.245 68.2233L157.451 64.2638L155.481 64.6587L155.086 62.6883L157.056 62.2934L156.659 60.3137L160.619 59.5201L159.43 53.5902L161.401 53.1953L162.986 61.1049L166.945 60.3113L166.549 58.3315L168.519 57.9366L168.916 59.9164L170.896 59.5196L169.31 51.61L167.331 52.0068L168.122 55.9569L164.172 56.7486L162.984 50.8187L161.004 51.2156L160.212 47.2655L158.242 47.6604L157.845 45.6806Z",
  fill: "#17204B"
});

var _ref38 = /*#__PURE__*/React.createElement("path", {
  d: "M126.613 53.9998L130.563 53.208L130.96 55.1878L134.919 54.3942L134.523 52.4144L136.493 52.0195L137.285 55.9696L131.355 57.1581L131.752 59.1379L127.801 59.9296L127.405 57.9498L129.384 57.553L128.99 55.5827L127.01 55.9795L126.613 53.9998Z",
  fill: "#17204B"
});

var _ref39 = /*#__PURE__*/React.createElement("path", {
  d: "M146.382 50.0374L144.403 50.4342L144.799 52.414L146.779 52.0172L146.382 50.0374Z",
  fill: "white"
});

var _ref40 = /*#__PURE__*/React.createElement("path", {
  d: "M166.142 46.0769L168.122 45.6801L168.914 49.6302L164.963 50.4219L164.569 48.4516L166.539 48.0566L166.142 46.0769Z",
  fill: "white"
});

var _ref41 = /*#__PURE__*/React.createElement("path", {
  d: "M174.052 44.4916L172.072 44.8884L172.864 48.8385L174.844 48.4417L174.052 44.4916Z",
  fill: "white"
});

var _ref42 = /*#__PURE__*/React.createElement("path", {
  d: "M176.031 44.0948L174.052 44.4916L174.843 48.4417L176.823 48.0449L176.031 44.0948Z",
  fill: "#17204B"
});

var _ref43 = /*#__PURE__*/React.createElement("path", {
  d: "M128.99 55.5828L127.01 55.9796L127.407 57.9594L129.386 57.5626L128.99 55.5828Z",
  fill: "white"
});

var _ref44 = /*#__PURE__*/React.createElement("path", {
  d: "M140.849 53.2057L138.869 53.6025L139.266 55.5823L141.246 55.1855L140.849 53.2057Z",
  fill: "#17204B"
});

var _ref45 = /*#__PURE__*/React.createElement("path", {
  d: "M170.893 49.2334L172.864 48.8385L173.26 50.8183L175.24 50.4215L176.429 56.3513L178.408 55.9545L179.597 61.8844L177.617 62.2812L178.014 64.2609L176.034 64.6577L176.429 66.6281L178.409 66.2313L178.014 64.2609L179.994 63.8641L181.182 69.794L177.223 70.5876L176.826 68.6078L174.856 69.0027L174.459 67.023L172.479 67.4198L171.687 63.4697L175.637 62.678L175.241 60.6982L177.22 60.3014L176.825 58.3311L174.846 58.7279L175.241 60.6982L173.27 61.0931L172.479 57.143L174.449 56.7481L173.657 52.798L171.687 53.193L170.893 49.2334Z",
  fill: "white"
});

var _ref46 = /*#__PURE__*/React.createElement("path", {
  d: "M174.843 48.4417L172.864 48.8385L173.26 50.8183L175.24 50.4215L174.843 48.4417Z",
  fill: "#17204B"
});

var _ref47 = /*#__PURE__*/React.createElement("path", {
  d: "M176.823 48.045L174.844 48.4418L175.24 50.4215L177.22 50.0247L176.823 48.045Z",
  fill: "white"
});

var _ref48 = /*#__PURE__*/React.createElement("path", {
  d: "M135.711 58.3443L133.731 58.7411L134.128 60.7208L136.108 60.324L135.711 58.3443Z",
  fill: "#17204B"
});

var _ref49 = /*#__PURE__*/React.createElement("path", {
  d: "M141.631 57.1577L137.681 57.9495L138.078 59.9292L142.028 59.1375L141.631 57.1577Z",
  fill: "#17204B"
});

var _ref50 = /*#__PURE__*/React.createElement("path", {
  d: "M155.471 54.3838L157.451 53.987L158.242 57.9371L154.292 58.7288L153.897 56.7584L155.868 56.3635L155.471 54.3838Z",
  fill: "#17204B"
});

var _ref51 = /*#__PURE__*/React.createElement("path", {
  d: "M177.22 50.0247L175.24 50.4215L176.429 56.3514L178.409 55.9545L177.22 50.0247Z",
  fill: "#17204B"
});

var _ref52 = /*#__PURE__*/React.createElement("path", {
  d: "M130.178 61.5126L132.148 61.1177L132.543 63.088L134.523 62.6912L134.92 64.671L128.99 65.8595L128.593 63.8798L130.573 63.4829L130.178 61.5126Z",
  fill: "#17204B"
});

var _ref53 = /*#__PURE__*/React.createElement("path", {
  d: "M138.088 59.9273L136.108 60.3241L136.505 62.3039L138.484 61.907L138.088 59.9273Z",
  fill: "#17204B"
});

var _ref54 = /*#__PURE__*/React.createElement("path", {
  d: "M142.028 59.1375L138.078 59.9292L138.475 61.909L142.425 61.1172L142.028 59.1375Z",
  fill: "white"
});

var _ref55 = /*#__PURE__*/React.createElement("path", {
  d: "M142.038 59.1356L144.008 58.7407L144.403 60.711L146.383 60.3142L146.78 62.294L138.87 63.8793L138.473 61.8995L142.433 61.1059L142.038 59.1356Z",
  fill: "#17204B"
});

var _ref56 = /*#__PURE__*/React.createElement("path", {
  d: "M152.313 59.1256L148.362 59.9174L148.759 61.8971L152.709 61.1054L152.313 59.1256Z",
  fill: "#17204B"
});

var _ref57 = /*#__PURE__*/React.createElement("path", {
  d: "M138.879 63.8774L136.9 64.2742L137.296 66.2539L139.276 65.8571L138.879 63.8774Z",
  fill: "#17204B"
});

var _ref58 = /*#__PURE__*/React.createElement("path", {
  d: "M146.78 62.2939L138.87 63.8793L139.267 65.859L147.176 64.2737L146.78 62.2939Z",
  fill: "white"
});

var _ref59 = /*#__PURE__*/React.createElement("path", {
  d: "M146.78 62.2939L148.759 61.8971L149.551 65.8472L147.571 66.244L147.968 68.2238L149.948 67.827L150.345 69.8067L148.365 70.2036L148.76 72.1739L146.78 72.5707L145.592 66.6408L139.662 67.8294L139.267 65.859L147.176 64.2737L146.78 62.2939Z",
  fill: "#17204B"
});

var _ref60 = /*#__PURE__*/React.createElement("path", {
  d: "M148.759 61.8971L152.709 61.1054L153.106 63.0852L151.126 63.482L152.315 69.4118L150.345 69.8067L149.948 67.827L147.968 68.2238L147.571 66.244L149.551 65.8472L148.759 61.8971Z",
  fill: "white"
});

var _ref61 = /*#__PURE__*/React.createElement("path", {
  d: "M154.689 60.7085L152.709 61.1053L153.106 63.0851L155.086 62.6883L154.689 60.7085Z",
  fill: "#17204B"
});

var _ref62 = /*#__PURE__*/React.createElement("path", {
  d: "M137.296 66.2539L129.387 67.8392L129.784 69.819L137.693 68.2337L137.296 66.2539Z",
  fill: "#17204B"
});

var _ref63 = /*#__PURE__*/React.createElement("path", {
  d: "M137.296 66.2539L139.267 65.859L139.662 67.8293L145.591 66.6408L146.78 72.5707L148.76 72.1738L148.365 70.2035L150.345 69.8067L150.74 71.777L152.71 71.3821L153.107 73.3619L151.136 73.7568L151.533 75.7366L147.574 76.5302L147.969 78.5005L151.928 77.7069L152.325 79.6866L150.345 80.0834L150.742 82.0632L146.792 82.8549L144.018 69.0155L130.178 71.7893L129.782 69.8096L137.691 68.2242L137.296 66.2539Z",
  fill: "white"
});

var _ref64 = /*#__PURE__*/React.createElement("path", {
  d: "M151.126 63.482L153.106 63.0852L154.69 70.9854L158.64 70.1937L159.433 74.1532L157.463 74.5481L157.858 76.5184L159.828 76.1235L160.225 78.1033L156.275 78.895L155.878 76.9152L153.898 77.312L154.295 79.2918L152.325 79.6867L151.928 77.7069L147.968 78.5006L147.574 76.5302L151.533 75.7366L151.136 73.7569L153.107 73.3619L152.71 71.3822L150.739 71.7771L150.345 69.8068L152.315 69.4119L151.126 63.482Z",
  fill: "#17204B"
});

var _ref65 = /*#__PURE__*/React.createElement("path", {
  d: "M153.106 63.0852L155.086 62.6884L155.481 64.6587L157.451 64.2638L158.245 68.2233L162.204 67.4297L162.599 69.4001L160.619 69.7969L161.808 75.7267L163.788 75.3299L164.184 77.3097L160.225 78.1033L159.828 76.1235L157.858 76.5184L157.463 74.5481L159.433 74.1532L158.64 70.1937L154.689 70.9854L153.106 63.0852Z",
  fill: "white"
});

var _ref66 = /*#__PURE__*/React.createElement("path", {
  d: "M161.016 61.4998L159.036 61.8966L159.828 65.8467L161.807 65.4499L161.016 61.4998Z",
  fill: "white"
});

var _ref67 = /*#__PURE__*/React.createElement("path", {
  d: "M176.825 58.3311L174.846 58.7279L175.243 60.7077L177.222 60.3109L176.825 58.3311Z",
  fill: "#17204B"
});

var _ref68 = /*#__PURE__*/React.createElement("path", {
  d: "M169.311 61.8868L163.381 63.0753L164.57 69.0052L170.499 67.8166L169.311 61.8868Z",
  fill: "white"
});

var _ref69 = /*#__PURE__*/React.createElement("path", {
  d: "M144.018 69.0155L130.179 71.7893L132.952 85.6288L146.792 82.8549L144.018 69.0155Z",
  fill: "#17204B"
});

var _ref70 = /*#__PURE__*/React.createElement("path", {
  d: "M167.737 64.2614L165.757 64.6582L166.154 66.638L168.134 66.2412L167.737 64.2614Z",
  fill: "#17204B"
});

var _ref71 = /*#__PURE__*/React.createElement("path", {
  d: "M179.597 61.8843L177.617 62.2811L178.014 64.2609L179.994 63.8641L179.597 61.8843Z",
  fill: "#17204B"
});

var _ref72 = /*#__PURE__*/React.createElement("path", {
  d: "M142.435 71.3921L132.555 73.3723L134.535 83.2522L144.415 81.272L142.435 71.3921Z",
  fill: "white"
});

var _ref73 = /*#__PURE__*/React.createElement("path", {
  d: "M178.014 64.2609L176.034 64.6577L176.431 66.6375L178.411 66.2407L178.014 64.2609Z",
  fill: "#17204B"
});

var _ref74 = /*#__PURE__*/React.createElement("path", {
  d: "M140.85 73.7592L134.92 74.9478L136.109 80.8776L142.039 79.6891L140.85 73.7592Z",
  fill: "#17204B"
});

var _ref75 = /*#__PURE__*/React.createElement("path", {
  d: "M164.976 70.983L162.996 71.3798L163.393 73.3595L165.373 72.9627L164.976 70.983Z",
  fill: "white"
});

var _ref76 = /*#__PURE__*/React.createElement("path", {
  d: "M166.946 70.588L168.926 70.1912L169.323 72.171L171.293 71.7761L171.688 73.7464L181.577 71.7643L181.974 73.744L179.994 74.1408L180.391 76.1206L176.441 76.9123L176.044 74.9325L168.135 76.5179L166.946 70.588Z",
  fill: "white"
});

var _ref77 = /*#__PURE__*/React.createElement("path", {
  d: "M172.876 69.3996L170.896 69.7964L171.293 71.7761L173.273 71.3793L172.876 69.3996Z",
  fill: "white"
});

var _ref78 = /*#__PURE__*/React.createElement("path", {
  d: "M155.878 76.9152L153.898 77.312L154.295 79.2918L156.275 78.895L155.878 76.9152Z",
  fill: "white"
});

var _ref79 = /*#__PURE__*/React.createElement("path", {
  d: "M152.325 79.6867L150.345 80.0835L150.742 82.0633L152.721 81.6664L152.325 79.6867Z",
  fill: "#17204B"
});

var _ref80 = /*#__PURE__*/React.createElement("path", {
  d: "M154.305 79.2898L152.325 79.6866L152.722 81.6664L154.701 81.2696L154.305 79.2898Z",
  fill: "white"
});

var _ref81 = /*#__PURE__*/React.createElement("path", {
  d: "M156.275 78.8949L154.295 79.2917L154.692 81.2715L156.672 80.8747L156.275 78.8949Z",
  fill: "#17204B"
});

var _ref82 = /*#__PURE__*/React.createElement("path", {
  d: "M160.225 78.1032L156.275 78.8949L156.672 80.8747L160.622 80.0829L160.225 78.1032Z",
  fill: "white"
});

var _ref83 = /*#__PURE__*/React.createElement("path", {
  d: "M181.974 73.7441L179.994 74.1409L180.391 76.1206L182.371 75.7238L181.974 73.7441Z",
  fill: "#17204B"
});

var _ref84 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M143.618 194.497L212.229 180.904C217.365 179.887 220.703 174.899 219.686 169.763L187.765 8.63949C186.748 3.50362 181.759 0.165119 176.624 1.18253L108.013 14.7753C102.877 15.7927 99.5384 20.7807 100.556 25.9166L132.476 187.04C133.494 192.176 138.482 195.514 143.618 194.497Z",
  stroke: "#202447",
  strokeWidth: 0.5
});

var _ref85 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M133.366 15.1652L152.349 11.1565L133.366 15.1652Z",
  fill: "#FEFEFE"
});

var _ref86 = /*#__PURE__*/React.createElement("path", {
  d: "M133.366 15.1652L152.349 11.1565",
  stroke: "#202447",
  strokeWidth: 0.5,
  strokeLinecap: "round"
});

var _ref87 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M156.225 10.0792C156.144 9.5412 156.514 9.03899 157.052 8.9579C157.59 8.87637 158.092 9.24686 158.174 9.78491C158.255 10.3225 157.885 10.8247 157.347 10.9063C156.809 10.9873 156.307 10.6173 156.225 10.0792Z",
  fill: "#202447"
});

var _ref88 = /*#__PURE__*/React.createElement("path", {
  d: "M130.948 61.3501C133.004 67.64 133.437 80.7955 115.074 100.484C115.074 100.484 116.174 112.038 125.802 123.867C135.43 135.696 143.133 176.685 129.653 191.265C129.653 191.265 124.94 196.379 120.106 196.379",
  stroke: "#202447",
  strokeWidth: 0.5,
  strokeLinecap: "round"
});

var _ref89 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M94.1664 104.006C94.1664 104.006 94.1414 87.3319 103.782 78.7509C110.697 72.5958 120.538 63.9418 125.55 59.5402C127.36 57.9511 130.2 58.7315 130.948 61.0208C133.004 67.3107 133.437 80.4658 115.074 100.155C115.074 100.155 116.174 111.708 125.802 123.537C135.43 135.366 143.133 176.355 129.653 190.935C116.174 205.515 87.5643 166.177 87.5643 166.177L94.1664 104.006Z",
  fill: "#C88E74"
});

var _ref90 = /*#__PURE__*/React.createElement("rect", {
  x: 131.151,
  y: 97.7981,
  width: 58,
  height: 4.27454,
  transform: "rotate(-12.0322 131.151 97.7981)",
  fill: "#C3C3C3"
});

var _ref91 = /*#__PURE__*/React.createElement("rect", {
  x: 133,
  y: 107.224,
  width: 49.0461,
  height: 4.27454,
  transform: "rotate(-12.0322 133 107.224)",
  fill: "#C3C3C3"
});

var _ref92 = /*#__PURE__*/React.createElement("rect", {
  x: 135.05,
  y: 117,
  width: 40.4912,
  height: 4.27454,
  transform: "rotate(-12.0322 135.05 117)",
  fill: "#C3C3C3"
});

function SvgHandPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 273,
    height: 281,
    viewBox: "0 0 273 281",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58, _ref59, _ref60, _ref61, _ref62, _ref63, _ref64, _ref65, _ref66, _ref67, _ref68, _ref69, _ref70, _ref71, _ref72, _ref73, _ref74, _ref75, _ref76, _ref77, _ref78, _ref79, _ref80, _ref81, _ref82, _ref83, _ref84, _ref85, _ref86, _ref87, _ref88, _ref89, _ref90, _ref91, _ref92);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandPhone);
export default __webpack_public_path__ + "static/media/hand_phone.3ec3893157a1f536f220fc2ca5af78f8.svg";
export { ForwardRef as ReactComponent };